import React, { useContext, useState } from 'react';
import { Options } from './Options';
import { Title } from '../../components/Title/Title';
import { Box, Grid } from '@mui/material';
import { SizeSelector } from './Options/SizeSelector';
import { BaseContainer } from '../BaseContainer/BaseContainer';
import { canvasHandFrameDataContext } from '../../context/canvasHandFrameDataContext';
import { canvasOptionsContext } from '../../context/canvasOptionsContext';
import { Comment } from '../../components/Comment/Comment';
import { Total } from "./Total";
import { CanvasButtonsList } from "../CanvasContainer/CanvasButtonsList";
import { canvasModeContext } from "../../context/canvasModeContext";
import { Collections } from "@mui/icons-material";
import { CollectionsContainer } from "../CollectionsContainer/CollectionsContainer";

interface IOptionsContainerProps {
    mode: string;
}

export function OptionsContainer({ mode }: IOptionsContainerProps) {
    const { options } = useContext(canvasOptionsContext);
    const [isDesktop] = useState(window.innerWidth > 991);
    const { isFlipped, setIsFlipped } = useContext(canvasModeContext);
    const url = new URL(window.location.href);
    const defaultGridCnt = url.searchParams.get('gridCnt') ? url.searchParams.get('gridCnt') : 0;
    const [gridCnt] = useState(defaultGridCnt ? parseInt(defaultGridCnt) : 7);

    const { handFrameData } = useContext(canvasHandFrameDataContext);

    const domContainer = document.querySelector('#constructor_app'),
          isSimpleMode = domContainer?.getAttribute('data-mode') === 'simpleMode',
          addedTopOption = isSimpleMode ? 1507 : 1107,
          topOptionIds = addedTopOption ? [1520, 1108].concat([addedTopOption]) : [1520, 1108];

    if(options && topOptionIds) {
        options.items.sort((a, b) => topOptionIds.indexOf(a.id) - topOptionIds.indexOf(b.id));
    }

    function calcTotalWidth(props: { width: number; height: number }) {
        const { width, height } = props;

        return Math.round((((Math.round(width) / 100) * Math.round(height)) / 100) * 10000) / 10000;
    }

    const calcOptionSquare = () => {
        const width = handFrameData.width;
        const height = handFrameData.height;
        return Math.round(calcTotalWidth({ width, height }) * 100) / 100;
    };

    return (
        <Grid
            id={'optionsContainer'}
            display="grid"
            gap="30px"
            sx={theme => ({
                [theme.breakpoints.up(991)]: {
                    m: '65px 0 0',
                },
            })}
        >
            <Grid display="grid" sx={{ gap: '30px' }}>
                <Title>Размер стены</Title>
                <Grid container flexWrap="nowrap" alignItems="center" gap="10px">
                    <SizeSelector mode={mode}/>
                    <Box>=</Box>
                    <Box>{calcOptionSquare()}м2</Box>
                </Grid>
                {/* Дополнительная группа свойств */}
                <Grid display="grid" gap="20px" mt={'-10px'}>
                    {/*{!isSimpleMode && topSizeOptions && <OptionsGroup {...topSizeOptions} />}*/}
                    {/*<Options mode={mode} setting={[]}/>*/}
                    <Options mode={mode} setting={topOptionIds}/>
                </Grid>
            </Grid>

            {!domContainer?.getAttribute('data-element-id') && <CollectionsContainer/>}
            {/*<BaseContainer/>*/}
            <Grid display="grid" gap="20px">
                <Options mode={mode}/>
                <Comment/>
            </Grid>
            {!isDesktop &&
                <div>
                    <Total/>
                        <CanvasButtonsList
                            onFlipClick={newIsFlipped => {
                                setIsFlipped(newIsFlipped);
                            }}
                            isFlipped={isFlipped}
                            gridCnt={gridCnt}
                        />
                    {/*<Buttons/>*/}
                </div>
            }
        </Grid>
    );
}
